
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * PriceRoundingPolicy enum
 */
class PriceRoundingPolicy {
  /**
   * Initialize enum with a given value
   * @param {PriceRoundingPolicy|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof PriceRoundingPolicy) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!PriceRoundingPolicy}
   * @param {!PriceRoundingPolicy} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof PriceRoundingPolicy)) {
      throw new TypeError('Instance of PriceRoundingPolicy is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!PriceRoundingPolicy}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!PriceRoundingPolicy}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === PriceRoundingPolicy.ROUND_DOWN.value) {
      return 'ROUND_DOWN'
    }
    if (this.value === PriceRoundingPolicy.ROUND_HALF_UP.value) {
      return 'ROUND_HALF_UP'
    }
    if (this.value === PriceRoundingPolicy.ROUND_UP.value) {
      return 'ROUND_UP'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!PriceRoundingPolicy}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!PriceRoundingPolicy}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!PriceRoundingPolicy} Created enum
   */
  static fromObject (other) {
    return new PriceRoundingPolicy(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
PriceRoundingPolicy.ROUND_DOWN = new PriceRoundingPolicy(0 + 0)
// noinspection PointlessArithmeticExpressionJS
PriceRoundingPolicy.ROUND_HALF_UP = new PriceRoundingPolicy(0 + 1)
// noinspection PointlessArithmeticExpressionJS
PriceRoundingPolicy.ROUND_UP = new PriceRoundingPolicy(0 + 2)

export { PriceRoundingPolicy };

/**
 * Fast Binary Encoding PriceRoundingPolicy field model
 */
class FieldModelPriceRoundingPolicy extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelPriceRoundingPolicy}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelPriceRoundingPolicy}
   * @param {PriceRoundingPolicy=} defaults Default value, defaults is new PriceRoundingPolicy()
   * @returns {!PriceRoundingPolicy} Result value
   */
  get (defaults = new PriceRoundingPolicy()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new PriceRoundingPolicy(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelPriceRoundingPolicy}
   * @param {!PriceRoundingPolicy} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelPriceRoundingPolicy };
